import React from "react";
import { Container, Typography, Paper } from "@mui/material";

// ----------------------
// Object Data
// ----------------------
const termsData = {
  title: "Terms & Conditions – Yubai",
  intro: `Welcome to Yubai! These Terms & Conditions (“Terms”) govern your use
  of the Yubai website and mobile application (collectively referred to
  as the “Platform”) operated by Yubai L.L.C-FZ, a limited liability
  company registered in the Meydan Free Zone, Dubai, United Arab
  Emirates.`,


  companyInfo: [
    "Company Name: Yubai L.L.C-FZ",
    "Legal Form: Limited Liability Company – Free Zone",
    "Address: Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.",
    "Jurisdiction: Meydan Free Zone Regulations, Dubai, United Arab Emirates",
    "Official Contact: WhatsApp – [+971582584444]",
  ],

  sections: [
    {
      heading: "1. Acceptance of Terms",
      text: `By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services.`,
    },
    {
      heading: "2. User Registration",
      text: `To access certain features of the Platform, you must register and create an account. You are responsible for maintaining the confidentiality of your login credentials and all activities that occur under your account.`,
    },
    {
      heading: "3. Eligibility",
      text: `Use of the Platform is permitted only for individuals who can form legally binding contracts under applicable law. Minors under 18 may use the platform only with the involvement of a parent or guardian.`,
    },
    {
      heading: "4. Information Collection",
      text: `We collect personal information including your name, phone number, email address, and shipping details in order to process
      your orders and improve our services. Please refer to our Privacy Policy for more details.`,
    },
    {
      heading: "5. International Orders",
      text: `Yubai accepts international orders and works with third-party shipping providers to fulfill deliveries. Please note that international shipping fees, customs duties, and taxes may apply and are the responsibility of the customer unless otherwise stated.`,
    },
    {
      heading: "6. Limitation of Liability",
      text: `To the fullest extent permitted by applicable law, Yubai disclaims all warranties and shall not be liable for any indirect, incidental, or consequential damages arising from the use of or inability to use the Platform.`,
    },
    {
      heading: "7. Changes to Terms",
      text: `We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on the Platform. Your continued use of the Platform following the posting of revised Terms means you accept and agree to the changes.`,
    },
    {
      heading: "8. Governing Law",
      text: `These Terms shall be governed by and construed in accordance with the laws and regulations of the Meydan Free Zone, Dubai, United Arab Emirates.`,
    },
  ],
};


function TermsConditions() {
  return (
    <Container>
      <Paper
        elevation={0}
        sx={{ padding: "10px", marginTop: "20px", marginBottom: "20px" }}
      >
        {/* Main Title */}
        <Typography
          variant="h2"
          gutterBottom
          sx={{
            fontSize: { xs: "23px", sm: "23px",md:"28px" },
            // fontWeight: 700,
            mb: 3,
            textAlign: "left",
            fontFamily: "Poppins_600SemiBold",
          }}
        >
          {termsData.title}
        </Typography>

        {/* Intro */}
        <Typography
          variant="body2"
          paragraph
          sx={{
            textAlign: "left",
            fontSize: { xs: "12px", sm: "14px",md:"16px" },
            lineHeight: "20px",
            fontFamily: "Poppins",
            color: "#666666",
          }}
        >
          {termsData.intro}
        </Typography>

        {/* Company Info */}
        <Typography
          variant="body2"
          paragraph
          sx={{
            textAlign: "left",
            fontSize: { xs: "12px", sm: "14px",md:"16px"  },
            lineHeight: "20px",
            color: "#666666",
            fontFamily: "Poppins",
          }}
        >
          {termsData.companyInfo.map((info, index) => (
            <p key={index} style={{ margin: 0 }}>
              {info}
            </p>
          ))}
        </Typography>

        {/* Sections */}
        {termsData.sections.map((section, index) => (
          <React.Fragment key={index}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontSize: { xs: "23px", sm: "23px" ,md:"24px"},
                // fontWeight: 700,
                mt: { xs: "20px", sm: "30px" },
                textAlign: "left",
              fontFamily: "Poppins_600SemiBold",
              }}
            >
              {section.heading}
            </Typography>
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{
                textAlign: "left",
                fontSize: { xs: "12px", sm: "14px",md:"16px" },
                lineHeight: "20px",
                fontFamily: "Poppins",
              }}
            >
              {section.text}
            </Typography>
          </React.Fragment>
        ))}
      </Paper>
    </Container>
  );
}

export default TermsConditions;
